import script from "./AiCheckDocumentList.vue?vue&type=script&setup=true&lang=js"
export * from "./AiCheckDocumentList.vue?vue&type=script&setup=true&lang=js"

import "./AiCheckDocumentList.vue?vue&type=style&index=0&id=ec63d202&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec63d202"]])

export default __exports__